import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"

// redirect away from legacy production domain to new one — must stop
// execution before React mounts so API calls don't fire from the legacy
// origin and get blocked by CORS
if (window.location.hostname === "management.intuidesk.com") {
  window.location.replace(
    "https://manage.intuidesk.com" +
      window.location.pathname +
      window.location.search +
      window.location.hash
  )
} else {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  )

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
